import React from 'react';
import classNames from 'classnames';

/** @type {React.FC<React.HTMLAttributes<HTMLElement> & {icon?: string, className?: import('classnames').Argument}>} */
const BaseIcon = ({ className, icon, ...props }) => (
  <i
    aria-hidden="true"
    className={classNames(className, 'font-normal', { [`fb-icon--${icon}`]: Boolean(icon) })}
    {...props}
  />
);

export default BaseIcon;
